import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import "./blurb.module.css";

const BlurbBase = ({ element, template = "", externalLink = false }) => {
  const supportedTemplates = ["blurb1", "blurb2", "blurb3"];
  const templateStyle = supportedTemplates.includes(template) ? `wrapper--${template}` : "wrapper";
  let text = element.text || "";
  if (externalLink) {
    text = element.text.replace(/<a/g, '<a target="_blank"');
  }

  return <div styleName={templateStyle} dangerouslySetInnerHTML={{ __html: text }} />;
};

BlurbBase.propTypes = {
  element: PropTypes.shape({
    text: PropTypes.string
  }).isRequired,
  template: PropTypes.oneOf(["blurb1", "blurb2", "blurb3", ""]),
  externalLink: PropTypes.bool
};

const mapStateToProps = state => ({
  template: get(state, ["qt", "config", "theme-attributes", "story-elements", "blurb"], "")
});

export const Blurb = connect(
  mapStateToProps,
  {}
)(BlurbBase);
